// extracted by mini-css-extract-plugin
module.exports = {"root":"AudioPlayer_root__r3SOs","player":"AudioPlayer_player__XxqaW"};